/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { confirmWrapper } from 'src/components/Dialog';
import API from '../../network';

function JobTerms() {
  const { orgId } = useParams();
  const [orgTerms, setOrgTerms] = useState<any>(null);

  const fetchJobTerms = async () => {
    try {
      API.getInstance().fetchOrgTermsById(Number(orgId)).then((data) => {
        setOrgTerms(data.terms);
      });
    } catch (error) {
      await confirmWrapper('Something went wrong', {
        variant: 'danger',
      });
    }
  };

  useEffect(() => {
    fetchJobTerms();
  }, [orgId]);

  return (
    <div className="mx-auto px-4 py-8 max-w-3xl text-left">
      <div className="bg-slate-50 w-full" dangerouslySetInnerHTML={{ __html: orgTerms }} />
    </div>
  );
}

export default JobTerms;
